import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const StackGlyph = /*#__PURE__*/createElement("g", {
  id: "stack",
  style: {
    transform: 'scale(3.5)'
  }
}, /*#__PURE__*/createElement("path", {
  d: "M10 17.5C12.5312 17.5 14.8454 17.1019 16.5452 16.4409C17.3935 16.111 18.1141 15.7058 18.6312 15.2304C19.1486 14.7546 19.5 14.1704 19.5 13.5C19.5 12.8296 19.1486 12.2454 18.6312 11.7696C18.1141 11.2942 17.3935 10.889 16.5452 10.5591C14.8454 9.8981 12.5312 9.5 10 9.5C7.46884 9.5 5.1546 9.8981 3.45482 10.5591C2.60651 10.889 1.88591 11.2942 1.36885 11.7696C0.85136 12.2454 0.5 12.8296 0.5 13.5C0.5 14.1704 0.85136 14.7546 1.36885 15.2304C1.88591 15.7058 2.60651 16.111 3.45482 16.4409C5.1546 17.1019 7.46884 17.5 10 17.5Z",
  fill: "white",
  stroke: "#303844"
}), /*#__PURE__*/createElement("path", {
  d: "M10 14.5C12.5312 14.5 14.8454 14.1019 16.5452 13.4409C17.3935 13.111 18.1141 12.7058 18.6312 12.2304C19.1486 11.7546 19.5 11.1704 19.5 10.5C19.5 9.82957 19.1486 9.24537 18.6312 8.76957C18.1141 8.29417 17.3935 7.88902 16.5452 7.55912C14.8454 6.8981 12.5312 6.5 10 6.5C7.46884 6.5 5.1546 6.8981 3.45482 7.55912C2.60651 7.88902 1.88591 8.29417 1.36885 8.76957C0.85136 9.24537 0.5 9.82957 0.5 10.5C0.5 11.1704 0.85136 11.7546 1.36885 12.2304C1.88591 12.7058 2.60651 13.111 3.45482 13.4409C5.1546 14.1019 7.46884 14.5 10 14.5Z",
  fill: "white",
  stroke: "#303844"
}), /*#__PURE__*/createElement("path", {
  d: "M10 11.5C12.5312 11.5 14.8454 11.1019 16.5452 10.4409C17.3935 10.111 18.1141 9.70583 18.6312 9.23043C19.1486 8.75463 19.5 8.17043 19.5 7.5C19.5 6.82957 19.1486 6.24537 18.6312 5.76957C18.1141 5.29417 17.3935 4.88902 16.5452 4.55912C14.8454 3.8981 12.5312 3.5 10 3.5C7.46884 3.5 5.1546 3.8981 3.45482 4.55912C2.60651 4.88902 1.88591 5.29417 1.36885 5.76957C0.85136 6.24537 0.5 6.82957 0.5 7.5C0.5 8.17043 0.85136 8.75463 1.36885 9.23043C1.88591 9.70583 2.60651 10.111 3.45482 10.4409C5.1546 11.1019 7.46884 11.5 10 11.5Z",
  fill: "white",
  stroke: "#303844"
}), /*#__PURE__*/createElement("path", {
  d: "M10 8.5C12.5312 8.5 14.8454 8.1019 16.5452 7.44088C17.3935 7.11098 18.1141 6.70583 18.6312 6.23043C19.1486 5.75463 19.5 5.17043 19.5 4.5C19.5 3.82957 19.1486 3.24537 18.6312 2.76957C18.1141 2.29417 17.3935 1.88902 16.5452 1.55912C14.8454 0.898097 12.5312 0.5 10 0.5C7.46884 0.5 5.1546 0.898097 3.45482 1.55912C2.60651 1.88902 1.88591 2.29417 1.36885 2.76957C0.85136 3.24537 0.5 3.82957 0.5 4.5C0.5 5.17043 0.85136 5.75463 1.36885 6.23043C1.88591 6.70583 2.60651 7.11098 3.45482 7.44088C5.1546 8.1019 7.46884 8.5 10 8.5Z",
  fill: "white",
  stroke: "#303844"
}));
const Stack = createSvg({
  name: 'stack',
  path: StackGlyph
});

export default Stack;
export { StackGlyph };
